import React from "react";
import "./MemoryCard.scss";

const MemoryCard = ({
  card,
  isFlipped,
  isMatched,
  isDisabled,
  onClick,
  cardBackImageUrl,
  cardBackgroundColor,
}) => {
  const cardClass = [
    "MemoryCard",
    isFlipped ? "is-flipped" : "",
    isMatched ? "is-matched" : "",
    isDisabled ? "is-disabled" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={cardClass}
      onClick={() => onClick(card)}
      disabled={isDisabled || isMatched}
      aria-label="Memory card"
    >
      <div className="MemoryCard-inner">
        <div
          className="MemoryCard-face MemoryCard-back"
          style={{
            backgroundImage: cardBackImageUrl ? `url(${cardBackImageUrl})` : undefined,
            backgroundColor: cardBackgroundColor || undefined,
          }}
        />
        <div
          className="MemoryCard-face MemoryCard-front"
          style={{
            backgroundImage: card.imageUrl ? `url(${card.imageUrl})` : undefined,
            backgroundColor: cardBackgroundColor || undefined,
          }}
        />
      </div>
    </button>
  );
};

export default MemoryCard;
